import { axiosApiInstance as axios } from './axiosApiInstance';

export async function getVersionHost() {
  const { data: { result } } = await axios.get<{ result: string; }>('/Test/GetVersion');
  return result;
}
